import React, { useState } from "react";
import { OrderContainer, ColorSelectorContainer } from "./style";
import { getOrders, changeOrderColor } from "api/product";
import Loading from "components/loading";
import EmptyState from "components/emptyState";
import NumberFormat from "components/numberFormat";
import { IoCheckmarkSharp } from "react-icons/io5";
import Button from "components/button";
import Modal from "components/modal";
const OrdersPage = () => {
  const [orders, setOrders] = React.useState(null);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalSelected, setModalSelected] = useState({});
  const [changeLoading, setChangeLoading] = useState(false);
  React.useLayoutEffect(() => {
    if (orders === null)
      getOrders()
        .then((res) => {
          setOrders(res.data.orders);
        })
        .catch((err) => {});
  }, [orders]);
  const dateShow = (date) => {
    const event = new Date(date);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return event.toLocaleDateString("fa-IR", options);
  };
  if (orders === null) {
    return <Loading />;
  }
  const changeColor = () => {
    setChangeLoading(true);
    changeOrderColor(modalSelected)
      .then(() => {
        window.location.reload();
      })
      .finally(() => {
        setChangeLoading(false);
      });
  };
  return (
    <OrderContainer>
      {orders.length > 0 ? (
        orders.map((order, index) => (
          <div className="order" key={index}>
            <div className="title-area">
              <div className="order-title">{order.title}</div>
              <div className="order-date">{dateShow(order.date)}</div>
            </div>

            <div className="steps">
              <div className="line" />
              {order.steps.map((step, index) => (
                <div
                  className={`step ${step.active ? "active" : ""}`}
                  key={index}
                >
                  {step.active ? (
                    <span>
                      <IoCheckmarkSharp />
                    </span>
                  ) : (
                    ""
                  )}
                  {step.title}
                </div>
              ))}
            </div>
            <div className="bottom-area">
              <div className="invoice-status">
                <div className="order-amount">
                  {NumberFormat({ value: order.amount })}
                </div>
                <div className="order-status">{order.status}</div>
              </div>
              <div className="order-actions">
                <a href={order?.link.url}>{order?.link.title}</a>
              </div>
            </div>
            {order?.can_change_color ? (
              <div className="options">
                <Button
                  title="تغییر رنگ"
                  onClick={() => {
                    setModalStatus(true);
                    setModalData(order?.color_options);
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {order?.notifications.map((notif, index) => (
              <div className="notife" key={index}>
                {notif}
              </div>
            ))}
          </div>
        ))
      ) : (
        <EmptyState message="سفارش ثبت شده‌ای وجود ندارد" />
      )}
      <Modal status={modalStatus} close={() => setModalStatus(false)}>
        <div className="modal-body">
          <ColorSelectorContainer>
            <h5>تغییر رنگ به:</h5>
            {modalData.map((color) => (
              <div
                className={`item ${
                  modalSelected?.id === color.id ? "selected" : ""
                }`}
                key={color.id}
                onClick={() => {
                  setModalSelected(color);
                }}
              >
                <div className="title-area">
                  <span
                    className="color"
                    style={{ backgroundColor: color.code }}
                  ></span>
                  {color.title}
                </div>
              </div>
            ))}
          </ColorSelectorContainer>
          <div className="buttons">
            <Button
              title="انصراف"
              onClick={() => setModalStatus(false)}
              btn="outline"
            />
            <Button
              title="تایید"
              disabled={!modalSelected?.id}
              loading={changeLoading}
              onClick={changeColor}
            />
          </div>
        </div>
      </Modal>
    </OrderContainer>
  );
};
export default OrdersPage;
